import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import EntityWrapper from "../../components/crm/style/EntityWrapper.style";
import { useCrm_task_statuses } from "../../hooks";

import FormHeaderWrapper from "../../components/forms/FormHeader.style";
import {
  exportReportToPdf,
  getPdfMargins,
} from "../../components/util/helpers";
import { Modal, Layout, Typography, Button, Space } from "antd";
import Surface from "../../components/layouts/Surface";
import Activity from "../../components/crm/components/activity/Activity";
import Feed from "../../components/crm/components/feed/Feed";
import moment from "moment";
const { Title, Text } = Typography;
const { Sider, Content } = Layout;

const Activities = (props) => {
  const {
    entity,
    entityId,
    branchId,
    entityName,
    reportId,
    branches,
    hasEmail,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const [feedReloadTimestamp, setFeedReloadTimestamp] = useState(false);
  const [items, setItems] = useState([]);
  const statuses = useCrm_task_statuses();

  const onReloadFeed = () => {
    setFeedReloadTimestamp(moment().format());
  };

  const setHeader = (doc, record) => {
    doc.setFontSize(16);
    doc.setTextColor(40);
    doc.setR2L(true);
    doc.setFont("Rubik", "normal"); // set font
    var title = "פעילויות";
    const margins = getPdfMargins(doc);
    var hLoc = doc.internal.pageSize.getWidth() - margins;
    var subTitle = entityName;
    const report = "תאריך הדפסה";
    const date = `${moment().format("HH:mm DD/MM/YYYY")}`;
    const reportDate = `${report} - ${date}`;
    doc.text(title, hLoc, 20, {
      align: "right",
    });
    doc.setFontSize(12);
    doc.text(subTitle, hLoc, 26, {
      align: "right",
    });
    doc.text(reportDate, margins, 20, {
      align: "left",
    });
    doc.text(reportId, margins, 26, {
      align: "left",
    });
  };

  const getItems = () => {
    let activities = [];
    if (items && items.length > 0) {
      items.forEach((i) => {
        let temp = {};
        if (i.event_id) {
          temp = {
            created_at: moment(i.event.created_at).format("DD/MM/YYYY"),
            duration: moment
              .duration(
                moment(i.event.end_time).diff(moment(i.event.start_time))
              )
              .asHours(),
            start_time: moment(i.event.start_time).format("HH:mm"),
            start_date: moment(i.event.start_time).format("DD/MM/YYYY"),
            status: "",
            body: i.event.body,
            subject: i.event.subject,
            type: "אירוע",
          };
        } else {
          const currentStatus =
            statuses &&
            i.task.status_id &&
            statuses.filter((j) => j.id === i.task.status_id)[0] &&
            statuses.filter((j) => j.id === i.task.status_id)[0].name;
          temp = {
            created_at: moment(i.task.created_at).format("DD/MM/YYYY"),
            duration: "",
            start_time: moment(i.task.due_date).format("HH:mm"),
            start_date: moment(i.task.due_date).format("DD/MM/YYYY"),
            status: intl.formatMessage({
              id: `app.dataSelect.status.${currentStatus}`,
            }),
            body: i.task.body,
            subject: i.task.subject,
            type: i.task.type === "task" ? "משימה" : "תיעוד",
          };
        }
        activities.push(temp);
      });
    }
    return activities;
  };

  const onPrint = () => {
    exportReportToPdf(
      entityName,
      getItems(),
      setHeader,
      null,
      null,
      null,
      getItems(),
      "paging",
      40,
      intl,
      "activities",
      {
        styles: { fontSize: 9 },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 20 },
          2: { cellWidth: 20 },
          3: { cellWidth: 25 },
          4: { cellWidth: 18 },
          5: { cellWidth: 90 },
          6: { cellWidth: 50 },
          7: { cellWidth: 20 },
        },
        margin: { top: 36 },
      },
      "l",
      "print"
    );
  };

  const setActivitiesItems = (arr) => {
    setItems(arr);
  };

  return (
    <Layout>
      <EntityWrapper hasTabs={true}>
        <Layout>
          <Sider
            width="400px"
            style={{ background: "transparent" }}
            className="fixed-position"
          >
            <div
              className="component"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <Space size="small">
                <Button type="primary" onClick={onPrint}>
                  {intl.formatMessage({
                    id: `app.actions.print_activities`,
                  })}
                </Button>
              </Space>
            </div>
            <Activity
              entity={entity}
              entityId={entityId}
              branchId={branchId}
              onReloadFeed={onReloadFeed}
              collapsed={true}
              stretched={true}
              sider={true}
              branches={branches}
              hasEmail={hasEmail}
            />
          </Sider>
          <Content className="activities-content">
            <Feed
              entity={entity}
              entityId={entityId}
              branchId={branchId}
              onReloadFeed={onReloadFeed}
              feedReloadTimestamp={feedReloadTimestamp}
              setItems={setActivitiesItems}
            />
          </Content>
        </Layout>
      </EntityWrapper>
    </Layout>
  );
};
export default Activities;
